<template>
  <div class="user-content-filtering-wrap">
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: "UserContentFiltering",
};
</script>
